/**
 * SIP maturity calculation (shared by web, mobile, calculator-service).
 */

export function calculateSip(monthlyInvestment, interestRate, years) {
  const monthly = Number(monthlyInvestment);
  const rate = Number(interestRate);
  const period = Number(years);

  if (
    !Number.isFinite(monthly) ||
    monthly < 500 ||
    monthly > 100000 ||
    !Number.isFinite(rate) ||
    rate < 1 ||
    rate > 30 ||
    !Number.isFinite(period) ||
    period < 1 ||
    period > 30
  ) {
    return {
      totalInvestment: 0,
      estimatedReturns: 0,
      maturityValue: 0,
      invalid: true,
    };
  }

  const months = period * 12;
  const monthlyRate = rate / 12 / 100;
  if (monthlyRate === 0) {
    const totalInvestment = monthly * months;
    return {
      totalInvestment: Math.round(totalInvestment),
      estimatedReturns: 0,
      maturityValue: Math.round(totalInvestment),
    };
  }

  const maturityValue =
    monthly * (((1 + monthlyRate) ** (months) - 1) / monthlyRate) * (1 + monthlyRate);
  const totalInvestment = monthly * months;
  const estimatedReturns = maturityValue - totalInvestment;

  return {
    totalInvestment: Math.round(totalInvestment),
    estimatedReturns: Math.round(estimatedReturns),
    maturityValue: Math.round(maturityValue),
  };
}
